module.exports = __webpack_public_path__ + "img/lili1.1ec41384.png";